import React from "react";
import QRCode from "react-qr-code";
import { encodePresenceQrValue } from "../../utils/presenceQr";

export default function CompanyQRCode({ presenceCode }) {
    if (!presenceCode) return null;

    const qrValue = encodePresenceQrValue(presenceCode);

    return (
        <div
            style={{
                textAlign: "center",
                padding: "20px",
                backgroundColor: "#f8f9fa",
                borderRadius: "12px",
                margin: "15px 0",
                border: "1px dashed var(--primary)",
            }}
        >
            <p style={{ marginBottom: "15px", fontWeight: 700, color: "var(--text-primary)" }}>
                Mostre este QR Code para o Freelancer
            </p>

            <div
                style={{
                    background: "#fff",
                    padding: "32px",
                    display: "inline-block",
                    borderRadius: "8px",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                }}
            >
                <QRCode
                    value={qrValue}
                    size={280}
                    level="H"
                    bgColor="#FFFFFF"
                    fgColor="#000000"
                />
            </div>

            <p style={{ marginTop: "15px", color: "var(--text-secondary)", fontSize: "14px" }}>
                Ou informe o código manualmente:
                <br />
                <strong
                    style={{
                        fontSize: "1.5rem",
                        letterSpacing: "4px",
                        color: "var(--primary-dark)",
                        display: "block",
                        marginTop: "5px",
                    }}
                >
                    {presenceCode}
                </strong>
            </p>

            <p style={{ marginTop: "10px", color: "var(--text-muted)", fontSize: "12px" }}>
                Aumente o brilho da tela, mantenha o celular firme e a uns 25–30cm de distância.
            </p>
        </div>
    );
}